import type { InputInputSlotProps, InputSlots } from "@mui/base"
import { Box, InputAdornment, TextField } from "@mui/material"
import type { ComponentPropsWithoutRef, FC } from "react"
import { twMerge } from "tailwind-merge"

import type { InputVariantsProps } from "@/components/common/InputField/inputFieldVariant"
import { FIELD_ERROR_CLASSES, FIELD_LABEL_CLASSES } from "@/constants/forms"

type CustomInputSlots = InputInputSlotProps & {
  label?: ComponentPropsWithoutRef<"label">
}

type InputFieldProps = {
  label?: string
  placeholder?: string
  error?: string
  slots?: InputSlots
  slotProps?: CustomInputSlots
  startAdornment?: React.ReactNode
  endAdornment?: React.ReactNode
  multiline?: boolean
  size?: "medium" | "large"
} & InputVariantsProps &
  ComponentPropsWithoutRef<"input">

/**
 * @deprecated Use AerosTextField for uncontrolled usage or FormTextField for controlled usage.
 * @see AerosTextField
 * @see FormTextField
 */
const InputField: FC<InputFieldProps> = ({
  label,
  placeholder,
  error,
  size,
  state,
  disabled,
  color,
  startAdornment,
  endAdornment,
  className,
  slots,
  slotProps,
  multiline,
  ...props
}) => {
  return (
    <Box className={className}>
      {label && (
        <label {...slotProps?.label} className={twMerge([FIELD_LABEL_CLASSES, slotProps?.label?.className])}>
          {label}
          {props.required && <span className='text-red-600'>*</span>}
        </label>
      )}
      <TextField
        {...props}
        multiline={multiline}
        placeholder={placeholder}
        error={!!error}
        disabled={disabled}
        fullWidth
        variant='outlined'
        slotProps={{
          ...slotProps,
          input: {
            startAdornment: startAdornment && <InputAdornment position='start'>{startAdornment}</InputAdornment>,
            endAdornment: endAdornment && <InputAdornment position='end'>{endAdornment}</InputAdornment>,
          },
        }}
      />
      {error && <p className={FIELD_ERROR_CLASSES}>{error}</p>}
    </Box>
  )
}

export default InputField
